var DayTogglerComponent = /** @class */ (function () {
    function DayTogglerComponent() {
    }
    Object.defineProperty(DayTogglerComponent.prototype, "value", {
        get: function () {
            return this.innerValue;
        },
        set: function (v) {
            this.innerValue = v;
            this.onModelChange(v);
        },
        enumerable: true,
        configurable: true
    });
    DayTogglerComponent.prototype.writeValue = function (v) {
        if (v === undefined) {
            return;
        }
        this.innerValue = v;
    };
    DayTogglerComponent.prototype.registerOnChange = function (fn) {
        this.onModelChange = fn;
    };
    DayTogglerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouch = fn;
    };
    DayTogglerComponent.prototype.setDisabledState = function (isDisabled) { };
    return DayTogglerComponent;
}());
export { DayTogglerComponent };
